import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function F() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('poweroceanapp');
    const { locale } = useRouter();

    return (
        <div className={`ef-app-pc-f ${css.efAppPCF}`}>
            <div className="text-wrapper">
                <p className="sub-title">{t('sec6_subtitle')}</p>
                <p className="title">{t('sec6_title')}</p>
            </div>

            <div className="panel">
                <div className="left">
                    <p className="title-f">{t('sec6_title2')}</p>
                    <p className="desc-f">{t('sec6_desc2')}</p>
                </div>
                <NextImage
                    webpSrc={require('@publicLocal/power-ocean/app/6.webp')}
                    src={require('@publicLocal/power-ocean/app/6.png')}
                    alt={t('sec6_title')}
                    aria-label={t('sec6_title')}
                />
            </div>
        </div>
    );
}
